"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWidgetNotification = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../../utils/theme");
exports.StyledWidgetNotification = styled_components_1.default.div({
    backgroundColor: theme_1.colors.grey1,
    color: theme_1.colors.grey7,
    fontSize: '13px',
    fontWeight: 500,
    letterSpacing: '0.8px',
    padding: '11px 35px',
    textAlign: 'center',
}, function (_a) {
    var type = _a.type;
    if (type === 'warning') {
        return {
            backgroundColor: 'rgba(238, 58, 54, 0.1)',
            color: theme_1.colors.red1,
        };
    }
    if (type === 'success') {
        return {
            backgroundColor: theme_1.colors.green0,
            color: theme_1.colors.green1,
        };
    }
    return null;
});
//# sourceMappingURL=styles.js.map